export function envFlag(
  value: string | boolean | undefined,
  defaultValue = true,
) {
  if (typeof value === "boolean") return value;
  if (value === undefined || value === "") return defaultValue;
  return !["0", "false", "no", "off"].includes(value.toLowerCase());
}

export const features = {
  duels: envFlag(import.meta.env.VITE_ENABLE_DUELS),
  openLobby: envFlag(import.meta.env.VITE_ENABLE_OPENLOBBY),
} as const;

if (import.meta.vitest) {
  const { describe, expect, it } = import.meta.vitest;

  describe("envFlag", () => {
    it.each(["0", "false", "FALSE", "no", "off"])(
      "disables a feature for %s",
      (value) => expect(envFlag(value)).toBe(false),
    );

    it.each(["1", "true", "yes", "on"])("enables a feature for %s", (value) =>
      expect(envFlag(value, false)).toBe(true),
    );

    it("uses the requested default for an unset value", () => {
      expect(envFlag(undefined)).toBe(true);
      expect(envFlag(undefined, false)).toBe(false);
    });
  });
}
